export default __webpack_public_path__ + "static/spacerownik_wroclaw_okladka-490px-d994b28ddc43e70230e91a3cca73f4a7.jpg";